<nz-card nzTitle="Material Colours">
  <ng-container *ngIf="error$ | async as errorMsg; else resultTpl">
    <em-error-result [subTitle]="errorMsg"></em-error-result>
  </ng-container>

  <ng-template #resultTpl>
    <nz-skeleton [nzActive]="true" [nzLoading]="(loading$ | async) ?? false">
      <nz-table
        *ngIf="uiState$ | async as uiState"
        #materialColourTable
        [nzData]="(familyTrees$ | async) ?? []"
        [nzLoading]="familyTreesLoading$ | async"
        nzSize="small"
      >
        <thead>
          <tr>
            <th>Physical material</th>
            <th>Colour</th>
            <th>Info code</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let familyTree of materialColourTable.data; trackBy: trackByRef">
            <td>{{ familyTree.physicalMaterial }}</td>
            <td>
              <div class="colours-container">
                {{ familyTree.colourId }}
                <nz-divider nzType="vertical"></nz-divider>
                <nz-alert
                  *ngIf="uiState[familyTree.id]?.error as errorMessage; else bricksOrLoading"
                  nzType="error"
                  [nzMessage]="errorMessage"
                  nzShowIcon
                ></nz-alert>
                <ng-template #bricksOrLoading>
                  <nz-spin [nzSpinning]="uiState[familyTree.id]?.loading ?? false">
                    <div class="colour-brick-container">
                      <em-colour-brick
                        *ngFor="let colour of familyTree.colours; trackBy: trackByRef"
                        [name]="colour.colourDescription"
                        [red]="colour.red"
                        [green]="colour.green"
                        [blue]="colour.blue"
                      ></em-colour-brick>
                    </div>
                  </nz-spin>
                </ng-template>
              </div>
            </td>
            <td>{{ familyTree.infoCode }}</td>
          </tr>
        </tbody>
      </nz-table>
    </nz-skeleton>
  </ng-template>
</nz-card>
